export default class Constants {
    // static USERNAME_REGEX = /^[a-zA-Z][a-zA-Z0-9-_]{5,31}$/;
    static USERNAME_REGEX = /^[a-zA-Z][a-zA-Z0-9-_.]{3,31}$/;
    // static EMAIL_REGEX = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    static EMAIL_REGEX = /^[a-zA-Z][a-zA-Z0-9-_.]{3,31}$/;
    static OTP_REGEX = /^[0-9]{2,5}$/;
    // static PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%&]).{8,255}$/;
    static PASSWORD_REGEX = /^[ -~]{3,255}$/;
    static NAME_REGEX = /^[\p{L}\p{N}\p{M}&.\s-]{3,255}$/u;
    static PHONE_NUMBER_REGEX = /^[6-7][1-5][0-9]{6}$/; // starts with 6, second digit in range(1-5), then any number
    static UNSIGNED_DOUBLE_REGEX = /^[0-9.]{0,14}$/;
    static UNSIGNED_INTEGER_REGEX = /^[0-9]{0,100}$/;
    static PHONE_CODE = "+993";

    static UNAUTHORIZED = "Unauthorized";
    static BASE_CURRENCY = "TMT";
    
    // Role types — see server/helper/constants.js for the authoritative definition.
    static ROOT = 'ROOT';
    static ADMIN = 'ADMIN';
    static CASHIER = 'CASHIER';
    static CUSTOM = 'CUSTOM';
    static ROLE_TYPES = [this.ROOT, this.ADMIN, this.CASHIER, this.CUSTOM];
    static SUPER_ROLE_TYPES = [this.ROOT, this.ADMIN];
    // Only a CUSTOM role may be deleted; the rest drive routing and permission
    // bypasses. The server enforces this - mirrored here to hide the action.
    static PROTECTED_ROLE_TYPES = [this.ROOT, this.ADMIN, this.CASHIER];

    static ROLE_PATH_PREFIX = {
        [this.CASHIER]: "/cp",
    };

    // The built-in app passwords. A user may hold one per type and nothing else -
    // the name is not free text. Keep in step with server/helper/constants.js,
    // which also maps the numeric names used before the rename.
    static APP_PASSWORD_CASHIER = 'CASHIER';
    static APP_PASSWORD_WAREHOUSE = 'WAREHOUSE';
    static APP_PASSWORD_TYPES = [this.APP_PASSWORD_CASHIER, this.APP_PASSWORD_WAREHOUSE];

    // Calculator
    static DIGITS = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.'];
    static NUM_PADS = [['1', '2', '3'], ['4', '5', '6'], ['7', '8', '9'], ['.', '0', '<']];

    // ---------------------- LINKS ------------------------------------
    // Links Main
    static DASHBOARD_LINKS = [ '/' ];

    static PRODUCT_PRODUCTS_LINKS = [ '/product/products', '/product/products/:id', '/product/products/create' ];
    static PRODUCT_OPERATIONS_LINKS = [ '/product/operations' ];
    static PRODUCT_LINKS = this.PRODUCT_PRODUCTS_LINKS.concat(this.PRODUCT_OPERATIONS_LINKS);

    static INVOICE_INVOICES_LINKS = [ '/invoice/invoices', '/invoice/invoices/:id', '/invoice/invoices/create' ];
    static INVOICE_INVOICE_ITEMS_LINKS = [ '/invoice/invoice-items' ];
    static INVOICE_INVOICE_RETURNS_LINKS = [ '/invoice/invoice-returns' ];
    static INVOICE_LINKS = this.INVOICE_INVOICES_LINKS.concat(this.INVOICE_INVOICE_ITEMS_LINKS, this.INVOICE_INVOICE_RETURNS_LINKS);
    
    static WAREHOUSE_WAREHOUSES_LINKS = [ '/warehouse/warehouses' ];
    static WAREHOUSE_WRITTEN_OFF_PRODUCTS_LINKS = [ '/warehouse/written-off-products','/warehouse/written-off-products/create' ];
    static WAREHOUSE_AUDITS_LINKS = [ '/warehouse/audits', '/warehouse/audits/:id' ];
    static WAREHOUSE_LINKS = this.WAREHOUSE_WAREHOUSES_LINKS.concat(this.WAREHOUSE_WRITTEN_OFF_PRODUCTS_LINKS, this.WAREHOUSE_AUDITS_LINKS);

    static SALE_SALES_LINKS = ['/sale/sales'];
    static SALE_SALE_ITEMS_LINKS = ['/sale/sale-items'];
    static SALE_RETURNED_SALES_LINKS = ['/sale/returned-sales'];
    static SALE_LINKS = this.SALE_SALES_LINKS.concat(this.SALE_SALE_ITEMS_LINKS, this.SALE_RETURNED_SALES_LINKS);

    static REPORTS_GENERAL_LINKS = ['/reports/general'];
    static REPORTS_ANALYTICS_LINKS = ['/reports/analytics'];
    static REPORTS_COMPARE_LINKS = ['/reports/compare'];
    static REPORTS_LINKS = this.REPORTS_GENERAL_LINKS.concat(this.REPORTS_ANALYTICS_LINKS, this.REPORTS_COMPARE_LINKS);

    static COMPANY_EXPENSES_LINKS = ['/company/expenses'];
    static COMPANY_SUPPLIERS_LINKS = [ '/company/suppliers' ];
    static COMPANY_CONTACTS_LINKS = [ '/company/contacts' ];
    static COMPANY_BRANCHES_LINKS = [ '/company/branches' ];
    static COMPANY_LINKS = this.COMPANY_EXPENSES_LINKS.concat(this.COMPANY_SUPPLIERS_LINKS, this.COMPANY_SUPPLIERS_LINKS, this.COMPANY_CONTACTS_LINKS, this.COMPANY_BRANCHES_LINKS);

    // The main panel's modules, in the order they appear in the navigation bar. The
    // first link of a module is where it opens. MainWrapper builds the nav from this
    // and AdminLayout picks the landing page from it, so a user whose role excludes
    // DASHBOARD starts on the first module they are actually allowed.
    static MAIN_MODULES = [
        { id: 'DASHBOARD', links: this.DASHBOARD_LINKS },
        { id: 'PRODUCT', links: this.PRODUCT_LINKS },
        { id: 'INVOICE', links: this.INVOICE_LINKS },
        { id: 'WAREHOUSE', links: this.WAREHOUSE_LINKS },
        { id: 'SALE', links: this.SALE_LINKS },
        { id: 'COMPANY', links: this.COMPANY_LINKS },
        { id: 'REPORTS', links: this.REPORTS_LINKS },
    ];

    // Where a user with no main module at all is sent. Profile is not module-gated.
    static FALLBACK_HOME_LINK = '/profile/general';

    // Links Settings -------------------------------------------

    static SETTINGS_GENERAL_LINKS = [
        '/settings/general',
        '/settings/general/categories',
        '/settings/general/expense-categories',
        '/settings/general/brands',
        '/settings/general/units',
        '/settings/product/variation-types',
        '/settings/product/variation-options',
        '/settings/general/manufacturers',
        '/settings/general/countries',
        '/settings/general/provinces',
        '/settings/general/districts'
    ];

    static SETTINGS_ADMINISTRATION_LINKS = [
        '/settings/administration',
        '/settings/administration/users',
        '/settings/administration/users/create',
        '/settings/administration/users/:id',
        '/settings/administration/logs',
        '/settings/administration/roles',
        '/settings/administration/backup'
    ];

    static SETTINGS_PROFILE_GENERAL_LINKS = [ '/profile/general' ]
    static SETTINGS_PROFILE_P_AND_S_LINKS = [ '/profile/privacy-and-security' ]
    static SETTINGS_PROFILE_LINKS = this.SETTINGS_PROFILE_GENERAL_LINKS.concat(this.SETTINGS_PROFILE_P_AND_S_LINKS);


    static MODULES = [ 'DASHBOARD', 'PRODUCT', 'INVOICE', 'WAREHOUSE', 'SALE', 'REPORTS', 'COMPANY', 'CASHIER_PANEL', 'SETTINGS', 'SETTINGS_ADMIN' ];

    static MODELS = [
        'USER', 'LOGIN', 'PASSWORD_CHANGE', 'PASSWORD_RESET',
        'AUDIT', 'AUDITED_PRODUCT', 'BACKUP', 'BRANCH', 'BRAND', 'CATEGORY', 'CONTACT', 'COUNTRY',
        'DISTRICT', 'EXPENSE', 'EXPENSE_CATEGORY', 'INVOICE', 'LOG',
        'MANUFACTURER', 'PRODUCT', 'PRODUCT_OPERATION', 'PROVINCE', 'REPORT', 'RETURNED_INVOICE_ITEM', 'RETURNED_SALE',
        'ROLE', 'SALE', 'SETTINGS', 'SUPPLIER', 'UNIT_MEASURE', 'VARIATION_OPTION', 'VARIATION_TYPE',
        'WAREHOUSE', 'WRITTEN_OFF_PRODUCT'
    ];
    
    static LOCALE = "tk-TM"; // en-EN ru-RU tk-TM

    static ACTION_TYPE = ['WRITE', 'UPDATE', 'DELETE', 'READ'];
    static PRODUCT_OPERATION_TYPE = ['INVOICE', 'INVOICE_RETURN', 'SALE', 'SALE_RETURN', 'AUDIT', 'WRITE_OFF'];
    static PAYMENT_TYPE = ['CASH', 'CARD', 'CASH+CARD'];
    static MONTHS = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
}